var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"margin-top-xs"},[_vm._m(0),_c('dv-scroll-board',{staticClass:"margin-top-sm realTimeList1",attrs:{"config":_vm.config}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"firstTitle margin-top-xs"},[_c('i'),_vm._v("维修记录")])
}]

export { render, staticRenderFns }